import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "./store/actions/products-actions";
import { AnimatePresence } from "framer-motion";
import AdminMentorias from "./pages/AdminMentorias";
import AdminIA from "./pages/AdminIA";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Footer from "./layout/Footer";
import HomeRedirect from "./components/auth/HomeRedirect";
import { AuthProvider } from "./components/context/AuthContext";
import About from "./pages/About";

import Mentorias from "./pages/Mentorias";
import AdminMetaPixel from "./pages/AdminPixel";


const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAdmin = useSelector((state) => state.auth.isAdmin);

  // 👇 estado global para controlar modales
  const [modalAbierto, setModalAbierto] = useState(false);

  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);

  return (
    <AuthProvider>
      {/* NAV */}

      {/* ROUTES */}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route element={<HomeRedirect />}>
            <Route path="/" element={<Home />} />
            <Route path="/sobre-mi" element={<About />} />
            <Route path="/mentorias" element={<Mentorias />} />
            <Route path="/admin-meta" element={<AdminMetaPixel />} />
        
            <Route path="/admin-ia" element={<AdminIA />} />
            <Route path="/admin-mentorias" element={<AdminMentorias />} />

          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>

      {/* FOOTER */}
      {!isAdmin && !modalAbierto && <Footer />}
    </AuthProvider>
  );
};

export default App;